module.exports = __webpack_public_path__ + "static/media/clear-select.a4d59af9.svg";